module.exports = __webpack_public_path__ + "img/view_explanation_3.24fe75fa.png";